import { render } from "./html-course.vue?vue&type=template&id=97ba5cfa&scoped=true"
import script from "./html-course.vue?vue&type=script&lang=js"
export * from "./html-course.vue?vue&type=script&lang=js"

import "./html-course.vue?vue&type=style&index=0&id=97ba5cfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ba5cfa"]])

export default __exports__